export default "__VITE_ASSET__D0EbJbja__"